var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qm-business-state" }, [
    _vm.visibleDot
      ? _c("i", {
          staticClass: "qm-business-state__dot",
          style: { backgroundColor: _vm.$currentInfo.color },
        })
      : _vm._e(),
    _c("span", { staticClass: "qm-business-state__text" }, [
      _vm._v(_vm._s(_vm.$currentInfo.text)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }